export default __webpack_public_path__ + "static/media/spam-modal.7d90d4a5.svg";